module.exports = __webpack_public_path__ + "static/media/SantoRostroSantisimaVirgenCoromoto300px.881f7ea1.jpg";